import { LanguageSelect } from '@/pages/agents/components/LanguageSelect';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Editor } from '@tiptap/core';
import { useRef, useState } from 'react';
import { RichEditor } from './RichEditor';
import { TagInput } from './TagInput';
import { VoicesSelect } from './VoicesSelect';

const Container = styled.div`
    margin-block: 72px;
    margin-inline: auto;
    max-width: 1000px;
    min-width: 515px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 100%;
`;

const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.56px;
`;

const TtsVoiceContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${theme.colors.secondary};
    border-radius: 0.5rem;
`;

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    gap: 24px;
    .MuiInputBase-root {
        height: 48px !important;
    }
`;
const VoiceContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`;

const RowContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const FieldLabel = styled.label`
    color: ${theme.colors.black[800]};
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 8px;
`;

const FieldDescription = styled.span`
    color: ${theme.colors.black[700]};
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.15px;
    margin-bottom: 8px;
`;

export const VoiceScript = () => {
    const [hoveredTag, setHoveredTag] = useState<string | null>(null);
    const editorRef = useRef<Editor | null>(null);

    return (
        <Container>
            <Title>Voice and script</Title>
            <FormContainer>
                <VoiceContainer>
                    <RowContainer>
                        <FieldLabel>Language</FieldLabel>
                        <LanguageSelect />
                    </RowContainer>
                    <RowContainer>
                        <FieldLabel>Voice</FieldLabel>
                        <TtsVoiceContainer>
                            <VoicesSelect labelOff={true} />
                        </TtsVoiceContainer>
                    </RowContainer>
                </VoiceContainer>
                <RowContainer>
                    <FieldLabel>Dynamic fields</FieldLabel>
                    <FieldDescription>
                        Add the personalized fields you plan to include in your script.
                        <br />
                        Make sure to write the fields exactly as they appear in your email marketing platform.{' '}
                    </FieldDescription>
                    <TagInput setHoveredTag={setHoveredTag} editorRef={editorRef} />
                </RowContainer>
                <RowContainer style={{ height: '100%' }}>
                    <FieldLabel>Script</FieldLabel>
                    <RichEditor hoveredTag={hoveredTag} editorRef={editorRef} />
                </RowContainer>
            </FormContainer>
        </Container>
    );
};
